import React from "react";
import {
    Container,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    Button,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { formatCurrencyDisplay, formatMoney } from '../../utils/moneyFormat';
import './EstimateView.css';
import { usePDF } from 'react-to-pdf';
import PointListTable from "./PointListTable";
import SplitToken from '../../mixins/SplitToken';

function InvoiceViewer({item, handleInvoiceClose}){
    const user = SplitToken();
    /// This page is for a processor to view an invoice they sent to a customer //
    const company = useSelector((state) => state.CompanyReducer.userCompanies[0]);
    const userData = useSelector((state)=> state.UserReducer.user);
    const dispatch = useDispatch();
    let data = [];
    let invoiceTotal = 0;
    let taxTotal = 0;
    let finalTotal = 0;
    let pointTypeTotal = 0;

    if (item?.invoiceValues != undefined) {
        data = JSON?.parse(item?.invoiceValues)

        for (let i = 0; i < data.items?.length; i++) {
            invoiceTotal += data.items[i].total;
        }
        for (let i = 0; i < data.taxes?.length; i++) {
            taxTotal += Number(data.taxes[i].total);
        }
        finalTotal = taxTotal.toFixed(2) + invoiceTotal.toFixed(2)

        pointTypeTotal = data.pointTypeTotal;

    };

    let pointList = [];
    if (item?.pointList != undefined) {
        if(item?.pointList != ""){
            pointList = JSON.parse(item?.pointList);
        }
    };

    /// For File name selection in invoice ///
    function getLastItem(thePath) {
        if (thePath == null || thePath == "") return "";
        var index = thePath.lastIndexOf('/') + 1;
        return thePath.substring(index);
    }

    /// For Creating and Downloading Invoice as CSV ///
    function exportToCsv() {
        let csvDownloadable = [
            [`${data.date}`, `${data?.customerInfo?.userCompany}`, `${item.fileName.split('.')[0]}`, `${formatMoney(data?.finalTotal)}`]
        ];
        let csvContent = "data:text/csv;charset=utf-8,"
            + csvDownloadable.map(e => e.join(",")).join("\n");

        var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, `${data?.customerInfo?.userCompany.replace(' ', '_')}-${item.fileName.split('.')[0]}`);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", `${data?.customerInfo?.userCompany.replace(' ', '_')}-${item.fileName.split('.')[0]}`);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }

    /// For Creating and Downloading Invoice as PDF ///
    const { toPDF, targetRef } = usePDF({ filename: `${data?.customerInfo?.userCompany.replace(' ', '_')}-${item?.fileName?.split('.')[0]}.pdf` });

    return (
        <Container id="invoice" className='estimatePage' maxWidth="sm">
            <Container ref={targetRef}>
                <Typography variant="h4" align="center">
                    Invoice
                </Typography>
                <Table>
                    <p style={{ display: "flex", justifyContent: 'right', width: "100%" }}>
                        <span style={{ marginRight: 50 }}>Date: {data.date}</span>
                        <span># {data.estimateNumber}</span>
                    </p>
                    <div style={{ display: 'flex' }}>
                        <div style={{ flex: 1, margin: 2 }}>
                            <div style={{ flex: 1, margin: 2 }}>
                                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', padding: 10 }}>
                                    <h4 style={{ display: "flex", justifyContent: 'left' }}>From:</h4>
                                    { data?.customerInfo ?
                                    <div>
                                        <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{data?.processorInfo?.name}</span></span>
                                        <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{data?.processorInfo?.street}</span></span>
                                        <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{data?.processorInfo?.city}, {data?.processorInfo?.state}</span></span>
                                        <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{data?.processorInfo?.zip}, {data?.processorInfo?.country}</span></span>
                                        <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{data?.processorInfo?.email}</span></span>
                                        <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{data?.processorInfo?.phoneNumber}</span></span>
                                    </div>
                                        :
                                    <div>
                                        <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{data?.botmarkInfo?.name}</span></span>
                                        <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{data?.botmarkInfo?.street}</span></span>
                                        <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{data?.botmarkInfo?.city}, {data?.botmarkInfo?.state}</span></span>
                                        <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{data?.botmarkInfo?.zip}, {data?.botmarkInfo?.country}</span></span>
                                        <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{data?.botmarkInfo?.email}</span></span>
                                        <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{data?.botmarkInfo?.phoneNumber}</span></span>
                                    </div>
                                    }
                                </div>
                            </div>
                            <div style={{ flex: 1, margin: 2 }}>
                                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', padding: 10 }}>
                                    <h4 style={{ display: "flex", justifyContent: 'left' }}>To:</h4>
                                    {data?.customerInfo ?
                                        <div>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>Company: {data?.customerInfo?.userCompany}</span></span>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>User: {data?.customerInfo?.customerName}</span></span>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>Email: {data?.customerInfo?.userEmail}</span></span>
                                            <br />
                                        </div>
                                    :
                                        <div>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>Company: {data?.processorInfo?.name}</span></span>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>User: {data?.processorInfo?.processorName}</span></span>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>Email: {data?.processorInfo?.email}</span></span>
                                            <br />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div style={{ flex: 1, margin: 2 }}>
                        </div>
                        <PointListTable pointList={pointList} name={item.fileName} id={item.id} pointTypeTotal={pointTypeTotal}/>
                    </div>
                </Table>
                <br />
                <Typography variant="body1">
                    <b>Invoice</b>
                </Typography>
                <br />
                <Table sx={{ border: "solid" }}>
                    <TableHead>
                        <TableRow><TableCell colSpan={7}></TableCell></TableRow>
                        <TableCell>Item</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>Qty</TableCell>
                        <TableCell>U/M</TableCell>
                        <TableCell>Rate</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell></TableCell>
                    </TableHead>
                    <TableBody>
                        {data?.items?.map((item, i) => (
                            <TableRow>
                                <TableCell>{item?.itemName}</TableCell>
                                <TableCell>{item?.description}</TableCell>
                                <TableCell>{item?.quantity}</TableCell>
                                <TableCell>{item?.unit}</TableCell>
                                <TableCell>{item?.rate}</TableCell>
                                <TableCell>{formatCurrencyDisplay(item?.total)}</TableCell>
                            </TableRow>
                        ))}
                        <br />
                        <br />
                        <br />
                        <TableRow><TableCell colSpan={7}></TableCell></TableRow>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell><b>Sub Total:</b></TableCell>
                            <TableCell>{formatCurrencyDisplay(invoiceTotal)}</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                        {data?.taxes?.map((item, i) => (
                            <TableRow>
                                <TableCell>{item?.itemName}</TableCell>
                                <TableCell>{item?.description}</TableCell>
                                <TableCell></TableCell>
                                <TableCell>{item?.unit}</TableCell>
                                <TableCell>{item?.rate}</TableCell>
                                <TableCell>{formatCurrencyDisplay(item?.total)}</TableCell>
                            </TableRow>
                        ))}
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell><b>Total:</b></TableCell>
                            <TableCell>{formatCurrencyDisplay(data?.finalTotal)}</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <br />
            </Container>
            <br />
            <Button onClick={() => exportToCsv()}>Download Invoice as .CSV</Button>
            <Button id="cmd" onClick={() => toPDF()}>Download Invoice as .PDF</Button>
        </Container>
    )
}

export default InvoiceViewer;